import { ChatMetricsWrapper } from "@/components/chat-metrics/chat-metrics-wrapper";

const ChatMetrics = () => {
  return (
    <div className="h-full flex flex-col bg-background p-6 text-text-500">
      <div className="flex-1">
        <ChatMetricsWrapper />
      </div>
    </div>
  );
};

export default ChatMetrics;
